import React from 'react';

const DoctorMinistry = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-3xl font-bold mb-4">Doctor of Ministry (DMin)</h2>
        <p className="mb-4" align="justify">
          The <strong>Doctor of Ministry (DMin)</strong> degree is an advanced professional degree program. It is directed at
          in-service participants engaged in full-time ministry. The program focuses on the practical aspects of the pastoral or missions
          ministry, including: Christian education, Christian counseling and psychology, and pastoral or administrative ministries. The DMin
          degree program empowers religious leaders to strengthen both their prophetic and pastoral competence while also equipping for ministry
          in the church, in religious education and in a variety of community-based ministries. The DMin degree is designed to empower
          people in ministry to become self-reliant and to take responsibility for their own learning needs from within the context of active
          ministry. It emphasizes learning as a process of action and reflection, or praxis, that takes place in the context of daily
          living. The degree invites learners to test their perceptions through processes of mutual inquiry and challenges doctoral participants to
          discover that they learn best when they discover insight for themselves rather than when someone else determines what they should
          know.
        </p>
        <p className="mb-4" align="justify">
          The Doctor of Ministry program creates a perfect opportunity for mid-career ministry or religious professionals to refresh and recreate their commitment to the task required of church and denominational leaders. Learners will think deeply about the current state of their church and denomination and their own leadership, creating imaginative new applications from what is learned and contributing new knowledge to the professional society.
        </p>
      </div>
    </div>
  );
};

export default DoctorMinistry;